import React from "react";
import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { TableAdministracionTipoProducto } from "../components/TableAdministracionTipoProductos";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook
import { useNavigate } from "react-router-dom";

export const AdminPageTipoProductos = () => {
  const navigate = useNavigate();
  const authProvider = useDynamicAuth(); // Usar el hook
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color-admin">
              <div className="title-name-admin">
                <div className="icon-goback-title-admin">
                  <button className="button-goback-style" onClick={() => navigate(-1)}>
                    <ArrowBackIosIcon />
                  </button>
                  <div> Administración de Tipo productos </div>
                </div>
              </div>
              <TableAdministracionTipoProducto />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
